import * as React from 'react';

function SvgBoardCircle(props) {
  return (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#board-circle_svg__clip0_1182_26667)" fill="#000" fillOpacity={0.45}>
        <path d="M6 .75a5.25 5.25 0 100 10.5A5.25 5.25 0 006 .75zm0 9.61a4.36 4.36 0 11.002-8.72A4.36 4.36 0 016 10.36z" />
        <path d="M7.308 3.711A1.976 1.976 0 006 3.234c-.492 0-.956.17-1.308.477-.366.32-.567.75-.567 1.21v.09c0 .051.042.093.094.093h.562a.094.094 0 00.094-.093v-.09c0-.516.505-.937 1.125-.937s1.125.42 1.125.938c0 .364-.258.698-.658.851a1.31 1.31 0 00-.843 1.24v.252c0 .052.042.094.093.094h.563a.094.094 0 00.094-.094V7a.566.566 0 01.362-.525c.691-.266 1.138-.875 1.138-1.552 0-.461-.2-.891-.566-1.211zM5.53 8.578a.469.469 0 10.938 0 .469.469 0 00-.938 0z" />
      </g>
      <defs>
        <clipPath id="board-circle_svg__clip0_1182_26667">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgBoardCircle;
